import styled, { keyframes } from 'styled-components';

const slideIn = keyframes` 
  0% {
    left: -100%;
    width: 0px;
  }
  100% { 
  left: 0;
  width: 350px; 
  }
`;

export const CheckboxGroupSection = styled.div`
  width: 100%;
  height: 100%;
  display: ${props => (props.direction === 'horizontal' ? 'block' : 'flex')};
  flex-wrap: wrap;
  flex-direction: ${props => (props.direction === 'vertical' ? 'column' : 'row')};
  column-gap: 5px;
  row-gap: 5px;
  align-items: ${props => (props.direction === 'vertical' ? '' : 'center')};
  justify-content: ${props => (props.direction === 'horizontal' ? '' : 'center')};

  .ant-checkbox,
  .ant-checkbox-inner {
    width: 22px;
    height: 22px;
  }
  .ant-checkbox-inner {
    border: 2px solid black;

    &::after {
      position: absolute;
      top: 42%;
      left: 28%;
      width: 30%;
      height: 60%;
      border: 2px solid #fff;
      border-color: ${props => `${props.color || '#fff'} !important`};
      border-top: 0;
      border-left: 0;
      content: ' ';
    }
  }
  .ant-checkbox .ant-checkbox-inner {
    background-color: ${props => `${props.backgroundColor || '#fff'} !important`};
    border-color: ${props => `${props.borderColor || '#fff'} !important`};
  }
  &.crossBox {
    .ant-checkbox .ant-checkbox-inner {
      background-color: ${props =>
        `${props.backgroundColor ? props.backgroundColor : '#000'} !important`};
      border-color: ${props => `${props.borderColor ? props.borderColor : '#000'} !important`};
      // border-color: #008100 !important;
      position: relative;
    }
    .ant-checkbox-checked .ant-checkbox-inner:before,
    .ant-checkbox-checked .ant-checkbox-inner:after {
      position: absolute;
      left: 46%;
      top: 25%;
      content: ' ';
      height: 50%;
      width: 2px;
      background-color: ${props => `${props.color || '#fff'} !important`};
      border-color: ${props => `${props.color || '#fff'} !important`};
      opacity: 1;
      font-size: 13px;
    }
    .ant-checkbox-inner:before {
      transform: rotate(45deg);
    }
    .ant-checkbox-inner:after {
      transform: rotate(-45deg);
      display: inline;
    }
  }
  &.squareBox {
    .ant-checkbox .ant-checkbox-inner {
      background-color: ${props => `${props.backgroundColor || '#fff'} !important`};
      border-color: ${props => `${props.borderColor || '#000'} !important`};
      position: relative;
    }
    .ant-checkbox-checked .ant-checkbox-inner:before {
      position: absolute;
      content: ' ';
      height: 35%;
      width: 35%;
      background-color: ${props => `${props.color || '#000'} !important`};
      border-color: ${props => `${props.color || '#000'} !important`};
      opacity: 1;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .ant-checkbox-inner:after {
      display: none !important;
    }
  }
  &.circleBox {
    .ant-checkbox .ant-checkbox-inner {
      background-color: ${props => `${props.backgroundColor || '#fff'} !important`};
      border-color: ${props => `${props.borderColor || '#000'} !important`};
      position: relative;
    }
    .ant-checkbox-checked .ant-checkbox-inner:before {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      content: ' ';
      height: 35%;
      width: 35%;
      background-color: ${props => `${props.color || '#000'} !important`};
      border-color: ${props => `${props.color || '#000'} !important`};
      opacity: 1;
      border-radius: 100%;
    }
    .ant-checkbox-inner:after {
      display: none !important;
    }
  }
`;

export const CheckboxGroupSettingsSection = styled.div`
  background: #fff;
  height: calc(100% - 70px);
  overflow-y: auto;
  padding-bottom: 20px;
  top: 10px;
  position: relative;
  z-index: 99;
  animation: ${props => (props.display ? slideIn : 'none')} 0.5s ease-in-out;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
  width: 350px;
  min-width: 350px;
  .invisible-quill {
    margin-top: 40px;
    .text-block-toolbar > .ql-toolbar.ql-snow {
      background-color: #fff !important;
      .ql-formats {
        .ql-font {
          color: #000 !important;
          border: 1px solid #000 !important;
          > span {
            color: #000 !important;
          }
        }
        > div > span > div {
          > button {
            background: #fff !important;
            > i {
              color: #000;
            }
          }
          > .ql-size {
            border: 1px solid #d9d9d9 !important;
            color: #000 !important;
          }
        }
      }
      .ql-stroke {
        stroke: #000;
      }
      .ql-fill {
        fill: #000;
      }
      .ql-custom-tray {
        > span {
          > button,
          > i {
            display: none !important;
          }
        }
      }
      #format-link,
      #formats-transform {
        display: none !important;
      }
      .ql-custom-tray {
        margin: auto;
      }
    }
    .selected {
      visibility: hidden !important;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  column-gap: 5px;
  align-items: center;
  .ant-checkbox-wrapper > .ant-checkbox {
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    > .ant-checkbox-inner {
      width: ${props => props.width}px;
      height: ${props => props.height}px;
    }
  }
`;

export const HorizontalLayout = styled.div`
  .ant-checkbox-wrapper {
    margin-right: 5px;
    vertical-align: middle;
  }
  > span {
    vertical-align: middle;
    &:first-of-type {
      margin-right: 5px;
    }
  }
  .ant-checkbox-wrapper > .ant-checkbox {
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    > .ant-checkbox-inner {
      width: ${props => props.width}px;
      height: ${props => props.height}px;
    }
  }

  .ant-radio-wrapper {
    margin-right: 5px !important;
    vertical-align: middle;
  }

  .ant-radio-wrapper > .ant-radio {
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    > .ant-radio-inner {
      width: ${props => props.width}px;
      height: ${props => props.height}px;
    }
  }
`;

export const RadiobuttonGroupSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${props => (props.direction === 'vertical' ? 'column' : 'row')};
  column-gap: 5px;
  row-gap: 5px;

  .ant-radio-wrapper {
    margin-right: 0;
  }
  .ant-radio-inner::after {
    top: 0;
    left: 0;
    margin: 25%;
    width: 50%;
    height: 50%;
    border-radius: 50%;
  }
  .ant-radio-inner {
    background: ${props => props.backgroundColor || '#fff'} !important;
    border-color: ${props => props.borderColor || '#000'} !important;
    border-radius: 50%;
  }

  .ant-radio-checked .ant-radio-inner {
    &::after {
      border-color: ${props => `${props.color || '#000'} !important`};
      background-color: ${props => `${props.color || '#000'} !important`};
    }
  }
`;

export const RadiobuttonWrapper = styled.div`
  display: flex;
  column-gap: 5px;
  align-items: center;
  .ant-radio-wrapper > .ant-radio {
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    > .ant-radio-inner {
      width: ${props => props.width}px;
      height: ${props => props.height}px;
    }
  }
`;
